import React from "react";

const WEBINAR_REGISTER_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfb4kc1ajrCrzrtgLwN0AKy0jlX0SB2whLlC6KMrBKsLdnS2w/viewform?usp=dialog";

const WebinarTicker = () => {
  return (
    <div className="webinar-ticker">
      <div className="container-fluid webinar-ticker-inner px-3 px-md-4">
        <div className="webinar-ticker-track" aria-label="Betel Jobs webinar announcement">
          <span className="webinar-ticker-text">
            Betel Jobs webinar will be held on 17th and 21st March. Register now.
          </span>
          <span className="webinar-ticker-text webinar-ticker-text-duplicate" aria-hidden="true">
            Betel Jobs webinar will be held on 17th and 21st March. Register now.
          </span>
        </div>

        <a
          href={WEBINAR_REGISTER_URL}
          target="_blank"
          rel="noreferrer"
          className="webinar-register-btn"
        >
          <span className="webinar-register-btn-sparkle" aria-hidden="true">
            ✦
          </span>
          <span className="webinar-register-btn-label">Register For Webinar</span>
        </a>
      </div>
    </div>
  );
};

export default WebinarTicker;
